import React from 'react';
import styled from 'styled-components';

import { CtaButton } from '../styled';

const Container = styled.div`
  padding: 0 25px;
`

const HomepageBannerImg = styled.img`
  max-width: 990px;
  margin: 0 auto 50px;
  display: block;
  border-radius: 12px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
`

function HomepageBanner({ input }) {
    return (
        <Container>
            <HomepageBannerImg src={input.primary.banner.url} />
        </Container>
    );
}

export { HomepageBanner };
